import { axios } from '../utils/apiUtils';
import React, { useState, useEffect } from 'react';
import { Alert, Button, Container, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import chungungoLogo from '../assets/images/logotipo-chungungo-flor.svg';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 12 },
};

const styles = {
  alert: {
    marginTop: '16px',
    marginBottom: '16px',
  },
};

const RecoverPassword = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState('');

  const [showError, setShowError] = useState();
  const [showModal, setShowModal] = useState(false);

  const sendResetPassword = (event) => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/users/send_password_reset_by_email/${email}`,
      {},
      {
        headers: { 'Content-Type': 'application/json' }
      },
    ).then((loginResponse) => {
      setShowModal(true);
    }).catch(() => {
      setShowError(true);
    });
  }


  return (
    <div id="recover-pass" class="text-center">
      <Modal show={showModal} >
        <Modal.Header closeButton>
          <Modal.Title>{t('login.password_reset.modal.title')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('login.password_reset.modal.message')}</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-success"
            href="/login"
          >{t('login.password_reset.modal.buttons.send')}</Button>
        </Modal.Footer>
      </Modal>
      <form class="form-recover" action="javascript:void(0)">
              <h1><img class="mb-4" src={chungungoLogo} alt="" width="190" height="" /></h1>
        {showError && 
          <Alert
            style={styles.alert}
            variant="danger" >
              {t('login.password_reset.modal.error')}
          </Alert>
        }
        <h2 class="pb-2">Recupera tu contraseña</h2>
        <p>Ingresa tu email, te enviaremos un enlace para recuperar la contraseña.</p>
        <label for="inputEmail" class="sr-only">Correo electrónico</label>
        <input class="form-control mb-2" type="email" id="inputEmail" placeholder="Usuario" required="" autofocus="" value={email} onChange={(event) => setEmail(event.target.value)} />
        <button class="btn btn-lg btn-primary btn-block mb-3" type="submit" onClick={() => sendResetPassword()} >Enviar el enlace</button>
        <a href="login.html" class="cursor-pointer">Volver</a>
      </form>
  </div>
    
  );
};

export default RecoverPassword;